<div class="rs-percent-control">
  <mat-form-field appearance="outline">
    <mat-label>{{placeholder | translate}}*</mat-label>
    <input [formControl]="rsFormControl" matInput mask="percent" suffix="%">
    <ng-content></ng-content>
  </mat-form-field>
</div>
